import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Modal, ModalFuss } from "./Modal.js";
export function useBestaetigung() {
    const [offen, setOffen] = useState(null);
    const offenRef = useRef(null);
    const antworten = useCallback((ja) => {
        const frage = offenRef.current;
        if (frage === null)
            return;
        offenRef.current = null;
        setOffen(null);
        frage.aufloesen(ja);
    }, []);
    const bestaetigen = useCallback((frage) => {
        if (offenRef.current !== null)
            return Promise.resolve(false);
        return new Promise((aufloesen) => {
            const eintrag = { ...frage, aufloesen };
            offenRef.current = eintrag;
            setOffen(eintrag);
        });
    }, []);
    // Aushängen mit offener Frage: abgelehnt — die Aktion, die sie schützte, ist ohnehin fort.
    useEffect(() => () => {
        const frage = offenRef.current;
        offenRef.current = null;
        frage?.aufloesen(false);
    }, []);
    const bestaetigung = offen === null ? null : createPortal(_jsx(Bestaetigung, { frage: offen, onAntwort: antworten }), document.body);
    return { bestaetigen, bestaetigung };
}
function Bestaetigung(p) {
    const text = useRef(null);
    const gefaehrlich = p.frage.gefaehrlich === true;
    /*
     * Einstiegsfokus NACH dem Öffnen (Effekt, nicht Layout-Effekt: `Modal` öffnet im
     * Layout-Effekt, und `showModal` setzt den Fokus selbst auf den ersten Knopf) — auf den
     * bestätigenden Knopf. Bei der Gefahr-Frage setzt ihn me-dialog selbst auf „Abbrechen“
     * (`autoFocus`, ModalFuss gefahr).
     */
    useEffect(() => {
        if (gefaehrlich)
            return;
        const host = text.current?.closest("me-dialog");
        host?.querySelector("button.ki-modal__primaer")?.focus();
    }, [gefaehrlich]);
    return (_jsxs(Modal, { titel: p.frage.titel, gestapelt: true, gefahr: gefaehrlich, onAbbrechen: () => p.onAntwort(false), children: [_jsx("div", { ref: text, className: "ki-bestaetigung__text", children: typeof p.frage.text === "string"
                    ? _jsx("p", { className: "ki-rueckfrage__text", children: p.frage.text }) : p.frage.text }), _jsx(ModalFuss, { speichernText: p.frage.bestaetigenText, gefahr: gefaehrlich, onSpeichern: () => p.onAntwort(true), onAbbrechen: () => p.onAntwort(false) })] }));
}
//# sourceMappingURL=useBestaetigung.js.map